import { createSelector } from "@ngrx/store";
import { AppState } from "../reducers";

const notificationsFeature = (state: AppState) => state.notifications;

export const activeNotifications = createSelector(
  notificationsFeature,
  (state) => ({
    activeNotifications: state.activeNotifications,
  }),
);
